/* ==========================================================================
   SPICY HOME - PREMIUM VIDEO HERO
   ========================================================================== */

(function () {
  'use strict';

  var roots = [];
  var ticking = false;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BRAND_WORDMARK = 'https://cdn.shopify.com/s/files/1/0986/3272/8922/files/spicy-logo-white.png?v=1785685257';

  function pickSource(root) {
    var s480 = root.getAttribute('data-src-480');
    var s720 = root.getAttribute('data-src-720');
    var s1080 = root.getAttribute('data-src-1080');
    var direct = root.getAttribute('data-src');
    var w = window.innerWidth || 1440;
    var conn = navigator.connection;

    if (conn && (conn.saveData || /(^|[^4])[23]g/.test(conn.effectiveType || ''))) {
      return s480 || s720 || direct || s1080;
    }
    if (w <= 767) return s720 || s480 || direct || s1080;
    if (w <= 1440) return s720 || s1080 || direct || s480;
    return s1080 || direct || s720 || s480;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function lengthToPx(value, viewport) {
    value = String(value || '').trim();
    var number = parseFloat(value);
    if (!isFinite(number)) return 0;
    if (value.indexOf('svh') > -1 || value.indexOf('vh') > -1) return viewport * number / 100;
    if (value.indexOf('px') > -1) return number;
    return number;
  }

  function upgradeBrandMark(root) {
    var brand = root.querySelector('.cine__brand');
    if (!brand || brand.querySelector('img')) return;

    brand.setAttribute('aria-label', 'SPICY HOME');
    brand.textContent = '';

    var img = document.createElement('img');
    img.src = BRAND_WORDMARK;
    img.alt = '';
    img.decoding = 'async';
    img.loading = 'eager';
    img.style.display = 'block';
    img.style.width = 'clamp(94px, 7.4vw, 128px)';
    img.style.height = 'auto';
    img.style.maxWidth = '42vw';

    brand.appendChild(img);
  }

  function prepareIncomingSection(root) {
    var viewport = window.innerHeight || document.documentElement.clientHeight || 1;
    var sectionShell = root.closest('.shopify-section') || root.parentElement;
    var nextSection = sectionShell && sectionShell.nextElementSibling;
    var stage = root.querySelector('[data-cine-stage]');

    if (!nextSection || !stage) return;

    var styles = window.getComputedStyle(root);
    var reveal = lengthToPx(styles.getPropertyValue('--cine-reveal'), viewport);
    var stageHeight = stage.getBoundingClientRect().height || viewport;
    var hiddenBeforeScroll = Math.max(0, viewport - stageHeight);
    var overlap = Math.max(0, reveal - hiddenBeforeScroll);

    sectionShell.style.position = 'relative';
    sectionShell.style.zIndex = '0';

    nextSection.style.position = 'relative';
    nextSection.style.zIndex = '6';
    nextSection.style.marginTop = overlap ? '-' + Math.round(overlap) + 'px' : '';
  }

  function updateReveal() {
    ticking = false;
    if (reducedMotion) return;

    roots = roots.filter(function (root) { return root.isConnected; });

    roots.forEach(function (root) {
      prepareIncomingSection(root);

      var stage = root.querySelector('[data-cine-stage]');
      var rect = root.getBoundingClientRect();
      var stageHeight = stage ? stage.getBoundingClientRect().height : 0;
      var travel = Math.max(1, root.offsetHeight - stageHeight);
      var progress = clamp(-rect.top / travel, 0, 1);
      root.style.setProperty('--cine-exit', progress.toFixed(4));
    });
  }

  function requestRevealUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateReveal);
  }

  function init(root) {
    if (root.__cineBooted) return;
    root.__cineBooted = true;

    upgradeBrandMark(root);
    roots.push(root);
    requestRevealUpdate();

    var video = root.querySelector('[data-cine-video]');
    var poster = root.querySelector('[data-cine-poster]');
    if (!video) {
      root.classList.add('is-ready');
      return;
    }

    var src = pickSource(root);
    if (!src) {
      root.classList.add('is-ready');
      return;
    }

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'metadata';
    video.src = src;
    video.load();

    function markReady() {
      root.classList.add('is-ready');
      if (poster) poster.classList.add('is-spent');
    }

    function play() {
      var p;
      try { p = video.play(); } catch (e) { markReady(); return; }
      if (p && p.catch) p.catch(function () {});
    }

    video.addEventListener('loadeddata', markReady, { once: true });
    video.addEventListener('canplay', play, { once: true });
    video.addEventListener('playing', markReady, { once: true });

    if (video.readyState >= 2) markReady();
    play();

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && video.paused) play();
    });
  }

  function boot(scope) {
    var found = (scope || document).querySelectorAll('[data-cine]');
    Array.prototype.forEach.call(found, init);
  }

  window.addEventListener('scroll', requestRevealUpdate, { passive: true });
  window.addEventListener('resize', requestRevealUpdate);
  window.addEventListener('orientationchange', requestRevealUpdate);
  window.addEventListener('load', requestRevealUpdate, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
